import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { filter, map, startWith } from 'rxjs';
import { AnalysisService } from '../../../analysis/application/services/analysis.service';
import { Permission } from '../../entities/permission.entity';
import { PermissionService } from '../../services/permission.service';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslocoPipe],
})
export class SidebarComponent {
  readonly layout = inject(LayoutService);
  readonly permissionService = inject(PermissionService);
  readonly Permission = Permission;
  private readonly router = inject(Router);
  private readonly analysisService = inject(AnalysisService);

  readonly downloadUrl = computed(() => {
    const d = this.analysisService.detail();
    return d?.reportUrl ?? d?.excelUrl ?? d?.pdfUrl ?? null;
  });

  downloadAnalysis(): void {
    const url = this.downloadUrl();
    if (url) {
      window.open(url, '_blank');
    }
  }

  readonly isOnAnalysisDetail = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(() => /^\/analysis\/details\/[^/]+$/.test(this.router.url)),
      startWith(/^\/analysis\/details\/[^/]+$/.test(this.router.url)),
    ),
    { initialValue: /^\/analysis\/details\/[^/]+$/.test(this.router.url) },
  );

  readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(() => this.router.url),
      startWith(this.router.url),
    ),
    { initialValue: this.router.url },
  );

  isModuleActive(prefix: string): boolean {
    return (this.currentUrl() ?? '').startsWith(prefix);
  }

  readonly analysisExpanded = signal(true);

  toggleAnalysis(): void {
    this.analysisExpanded.update((v: boolean) => !v);
  }

  constructor() {}

}